module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/654eddd856b9044e225152576d5e571b.png";